import { isProductionEnv, isStagingEnv } from 'constants';
import useCheckVersion from 'hooks/useCheckVersion';
import useLang from 'hooks/useLang';
import React from 'react';
import styled from 'styled-components';

const BuildVersionSection = () => {
  const { t } = useLang();
  const { currentVersion } = useCheckVersion();

  const envSuffix = isProductionEnv
    ? ''
    : isStagingEnv
    ? `_Staging`
    : `_Development`;

  return <Text>{`${t('label_version')}: ${currentVersion}${envSuffix}`}</Text>;
};

const Text = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: var(--ds-c-grey-dark);
  text-align: center;

  position: fixed;
  bottom: 76px;
  width: calc(100% - 32px);
  margin: 0;
  padding: 0;
`;

export default BuildVersionSection;
